// extracted by mini-css-extract-plugin
module.exports = {"content":"settings_content__3WwhH","button":"settings_button__3YOWP","empty":"settings_empty__2ZJMc","spin":"settings_spin__1el-I"};